import { fromNullable, getOrElse, toError } from 'fp-ts/lib/Either';
import { fromEither, IOEither, tryCatch } from 'fp-ts/lib/IOEither';
import { IO, io } from 'fp-ts/lib/IO';
import { pipe } from 'fp-ts/lib/pipeable';
import { fromIOEither } from 'fp-ts/lib/TaskEither';
import { ApiError } from '@/services/api';

export const TOKEN_KEY = 'token';
export const HASH_KEY = 'hash';

export const hasToken = (): boolean => pipe(
  window.localStorage.getItem(TOKEN_KEY),
  Boolean,
);

export const getToken = (): IOEither<ApiError, string> => pipe(
  window.localStorage.getItem(TOKEN_KEY),
  fromNullable(new ApiError(500, 'Token not set')),
  fromEither,
);

export const getTokenValue = () => pipe(
  getToken(),
  fromIOEither,
  async taskEither => getOrElse<ApiError, string | null>(() => null)(await taskEither()),
);

export const getTokenValueUnsafe = () => window.localStorage.getItem(TOKEN_KEY);
export const getHashValueUnsafe = () => sessionStorage.getItem(HASH_KEY);

export const setToken = (token: string): IOEither<Error, void> => tryCatch(
  () => window.localStorage.setItem(TOKEN_KEY, token),
  toError,
);

export const unsetToken = (): IO<void> => pipe(
  window.localStorage.removeItem(TOKEN_KEY),
  io.of,
);
